import type { IconNode } from '../types';

/**
 * @name emirati-dirham
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTEgNGE4IDggMCAwIDEgMCAxNkg2LjQwNkEuNC40IDAgMCAxIDYgMTkuNTk0VjQuNDA2QS40LjQgMCAwIDEgNi40MDYgNHoiIC8+CiAgPHBhdGggZD0iTTQgMTBoMTciIC8+CiAgPHBhdGggZD0iTTQgMTRoMTciIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/emirati-dirham
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const EmiratiDirham: IconNode = [
  ['path', { d: 'M11 4a8 8 0 0 1 0 16H6.406A.4.4 0 0 1 6 19.594V4.406A.4.4 0 0 1 6.406 4z' }],
  ['path', { d: 'M4 10h17' }],
  ['path', { d: 'M4 14h17' }],
];

export default EmiratiDirham;
